import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { OverlayBanner } from '@/components/shared/OverlayBanner';
import { CuboidPointVisibilityControls } from '@/modules/cuboids/components/CuboidToolbar/CuboidPointVisibilityControls';
import { Divider } from '@mui/material';
import { useCuboidDataHandlers, useCuboidState } from '../hooks';
import {
  CuboidSaveButtonGroup,
  CuboidTransformButtonGroup,
} from '@/modules/cuboids/components/CuboidToolbar';
import { editPointOfInterest as editPointOfInterestAtom } from '../../pointOfInterest/state';
import { useAtomValue } from 'jotai';
import { PointOfInterestTemplateTypeEnum } from '@/__generated__/graphql';
import { abyssColors } from '@/theme/colors';

const bannerSx = {
  mb: 2,
  py: 2,
  px: 3,
  '& .MuiButtonGroup-root': {
    paddingBottom: 0,
    gap: '0.4rem',
  },
  '& .MuiIconButton-root': {
    border: 'none',
    borderRadius: '0.6rem',
    padding: '0.5rem',
    marginLeft: 0,
    color: abyssColors.primary[700],
    width: '3.2rem',
    height: '3.2rem',
    '& .MuiSvgIcon-root': {
      color: 'inherit !important',
    },
  },
  '& .MuiIconButton-root:hover': {
    backgroundColor: abyssColors.primary[100],
  },
  // Active/selected state — white icon on dark background
  '& .MuiIconButton-root[style*="background: rgb(255, 255, 255)"], & .MuiIconButton-root[style*="background: #fff"]':
    {
      backgroundColor: abyssColors.primary[700],
      '& .MuiSvgIcon-root': {
        color: '#fff !important',
      },
    },
};

export const CustomBlocksCuboidControls = () => {
  const cuboidState = useCuboidState();
  const dataHandlers = useCuboidDataHandlers();

  const editPointOfInterest = useAtomValue(editPointOfInterestAtom);

  if (
    editPointOfInterest.template?.type ===
      PointOfInterestTemplateTypeEnum.PaintBlockVolumeOfInterest &&
    editPointOfInterest.state === 'WaitingForDetail'
  )
    return (
      <OverlayBanner sx={bannerSx} icon={<AbyssIcon iconName="cuboid-yellow" size="lg" />}>
        <CuboidPointVisibilityControls cuboidState={cuboidState} />
        <Divider orientation="vertical" flexItem />
        <CuboidTransformButtonGroup cuboidState={cuboidState} />
        <Divider orientation="vertical" flexItem />
        <CuboidSaveButtonGroup dataHandlers={dataHandlers} cuboidState={cuboidState} />
      </OverlayBanner>
    );

  return <></>;
};
